module.exports = __webpack_public_path__ + "img/20210906-1630911168264923.8bb21f5f.jpg";